export default "/_next/static/images/menu_line-e9bda7bf257b259a1717959af357ded8.svg";